import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { inject, PropType, ref, computed, onMounted } from "vue";
import { IBusStopData } from "@/domain/entities/busStop";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import MapOfBusStop from "@/views/map/MapOfBusStop.vue";
import ServiceEvaluationQuestions from "@/components/mypage/ServiceEvaluationQuestions.vue";
import { useSurveyStore } from "@/stores/surveyStore";
import { ISurvey } from "@/domain/entities/survey";
import { IBoardInfo } from "@/domain/entities/board";
import BoardHistoryDetailInfo from "@/components/board/BoardHistoryDetailInfo.vue";
import { useLineStore } from "@/stores/lineStore";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";
import PageModal from "@/components/shared/modal/base/PageModal.vue";


const __default__ = {
  name: "BoardHistoryDetail",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  boardInfo: {
    type: Object as PropType<IBoardInfo>,
    required: true,
  },
},
  emits: ["onClickClose", "onCompleteSurvey"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "3a6750c2-footerHeight": (footerHeight.value)
}))

dayjs.locale("ko");
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Seoul");

const props = __props;

const emit = __emit;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const surveyStore = useSurveyStore();
const lineStore = useLineStore();

const contentArea = ref<HTMLElement>();
const footerHeight = computed(() => (lineSurvey.value ? "70px" : "0px"));

const selectedBusStop = ref<IBusStopData | undefined>(undefined);
const shouldShowMap = ref(false);
const toggleShowMap = (show: boolean) => {
  shouldShowMap.value = show;
};

const emitOnClickClose = () => {
  emit("onClickClose");
};

const onClickBusStopLocation = (busStopId: string) => {
  selectedBusStop.value = lineStore.getBusStopById(busStopId);
  toggleShowMap(true);
};

// 서비스 평가 처리
const serviceEvaluationQuestions =
  ref<InstanceType<typeof ServiceEvaluationQuestions>>();

const isEvaluable = computed(() => !!serviceEvaluationQuestions.value?.isValid);

/** 서비스 평가 조회하기 */
const lineSurvey = ref<ISurvey>();
const getServiceEvaluation = async () => {
  const lineSurveyResult = await surveyStore.getServiceEvaluationContents();
  if (!lineSurveyResult.isSuccess) return;

  lineSurvey.value = lineSurveyResult.data;
};

const emitOnCompleteSurvey = () => {
  emit("onCompleteSurvey");
};

/** 서비스 평가 응답하기  */
const responseServiceEvaluation = async () => {
  if (!serviceEvaluationQuestions.value || !lineSurvey.value) return;

  const userAnswers = new Map(
    [...serviceEvaluationQuestions.value.userAnswers.entries()].sort()
  );

  const sendSurveyResult = await surveyStore.sendSurveyResult(
    lineSurvey.value.id,
    userAnswers,
    props.boardInfo.lineTurnUid,
    props.boardInfo.allocUid
  );

  if (!sendSurveyResult.isSuccess) {
    showErrorModal(
      "서비스평가 제출 오류",
      sendSurveyResult.errorMessage,
      sendSurveyResult.resultCode,
      sendSurveyResult.errorTime
    );
    return;
  }

  showToastMessage("서비스 평가가 완료되었습니다.", 3000, 350);
  getServiceEvaluation();
  emitOnCompleteSurvey();
};

onMounted(() => {
  getServiceEvaluation();
});

const __returned__ = { props, emit, showErrorModal, showToastMessage, surveyStore, lineStore, contentArea, footerHeight, selectedBusStop, shouldShowMap, toggleShowMap, emitOnClickClose, onClickBusStopLocation, serviceEvaluationQuestions, isEvaluable, lineSurvey, getServiceEvaluation, emitOnCompleteSurvey, responseServiceEvaluation, NavigationBar, FooterButton, MapOfBusStop, ServiceEvaluationQuestions, BoardHistoryDetailInfo, ScrollTopControl, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})